import CONSTANTS from '@/constants'
import { createAlgoliaIndices } from '@/utils'
import { mapState } from 'vuex'

export const sonarCommons = {
  methods: {
    async updateSessionStatus(status) {
      if (this.isStoppingLab) return
      if (status === CONSTANTS.LABS.SESSION_STATUS.TERMINATED)
        this.isStoppingLab = true
      this.isLoadingSession = true
      const response = await this.$store.dispatch(
        'labs/partialUpdateLabSession',
        {
          labId: this.currentLab.id,
          sessionId: this.currentLabSession.id,
          status,
          parentId: this.assessmentAttempt?.id,
          parentType: CONSTANTS.PARENT_CONTENT_TYPES_KEYS.ASSESSMENT,
        }
      )
      if (!this.isStoppingLab)
        this.$store.dispatch('labs/getLabById', {
          id: this.currentLab.id,
          parentId: this.assessmentAttempt?.id,
          parentType: CONSTANTS.PARENT_CONTENT_TYPES_KEYS.ASSESSMENT,
        })
      if (response && response.errorCode) {
        this.$emit('custom-lab-error', response.errorCode)
      } else {
        this.isLoadingSession = false
      }
      this.isStoppingLab = false
    },
  },
}

export const recommendedContent = {
  data() {
    return {
      currentItems: [],
      indices: {
        Courses: {},
        'Learning Paths': {},
        Videos: {},
        Bootcamps: {},
        Labs: {},
      },
    }
  },
  computed: {
    ...mapState({
      algoliaKeys: state => state.search.algoliaKeys,
      facets: state => state.search.facets,
      searchIndex: state => state.sonar.algoliaSearchIndex,
    }),
  },
  methods: {
    async getAlgoliaItems(payload) {
      const content = await this.$store.dispatch(
        'sonar/getAssessmentRecommendations',
        payload
      )
      const contentIds = content?.map(c => c.content_id)
      if (contentIds?.length) {
        this.createAlgoliaSearchInstance()
        const { results } = await this.searchIndex.algoliaIndex.getObjects(
          contentIds
        )
        return results
      }
      return []
    },
    createAlgoliaSearchInstance() {
      const {
        algoliaKeys: { appKey, appId, searchIndex },
      } = this
      const setup = {
        keys: {
          appId,
          appKey,
        },
        contexts: [
          {
            name: 'contentSearch',
            index: searchIndex,
            facets: this.facets.CONTENT,
          },
        ],
        disjunctiveFacets: true,
        initWithSearch: false,
      }
      const { instance, indices } = createAlgoliaIndices(setup)
      this.algoliaClient = instance
      this.$store.dispatch(
        'sonar/setAlgoliaSearchIndex',
        indices?.contentSearch
      )
    },
  },
}
